// extracted by mini-css-extract-plugin
export default {"skeleton-data-item":"e36605","skeleton-data-item__label":"c34936","pulse":"df825b","skeleton-data-item__value":"d7c39b"};